module.exports = __webpack_public_path__ + "ec586f013d1a1056c6d111eed05bd4c2.png";